import { render } from "./SelectSetting.vue?vue&type=template&id=f962bcb0&scoped=true"
import script from "./SelectSetting.vue?vue&type=script&lang=ts"
export * from "./SelectSetting.vue?vue&type=script&lang=ts"

import "./SelectSetting.vue?vue&type=style&index=0&id=f962bcb0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f962bcb0"

export default script